import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import {
    CoursePriceDetailsState,
    CoursePriceState,
    CoursePurchaseState,
    ListResponse,
    PaginationState,
} from '../types'

export const coursePriceApi = createApi({
    reducerPath: 'coursePriceApi',
    baseQuery: baseQueryWithIam,
    tagTypes: ['CoursePrice', 'CoursePurchase'],
    endpoints: (build) => ({
        fetchAllCoursesPrice: build.query<
            ListResponse<CoursePriceDetailsState>,
            PaginationState
        >({
            query: ({ page, size }) => ({
                url: `course-price`,
                params: {
                    page,
                    size,
                },
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result.data.map(({ id }) => ({
                              type: 'CoursePrice' as const,
                              id,
                          })),
                          { type: 'CoursePrice', id: 'LIST' },
                      ]
                    : [{ type: 'CoursePrice', id: 'LIST' }],
            transformResponse: (response: {
                data: ListResponse<CoursePriceDetailsState>
            }) => ({
                data: response.data.data,
                pageNumber: response.data.pageNumber,
                totalCount: response.data.totalCount,
                totalPages: response.data.totalPages,
            }),
        }),

        fetchCoursesForPurchase: build.query<CoursePurchaseState[], void>({
            query: () => ({
                url: '/purchase',
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result.map(({ id }) => ({
                              type: 'CoursePurchase' as const,
                              id,
                          })),
                          { type: 'CoursePurchase', id: 'LIST' },
                      ]
                    : [{ type: 'CoursePurchase', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        createCoursePrice: build.mutation<number, CoursePriceState>({
            query: (coursePrice) => ({
                url: 'course-price',
                method: 'POST',
                body: coursePrice,
            }),
            invalidatesTags: [{ type: 'CoursePrice', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        updateCoursePrice: build.mutation<void, CoursePriceState>({
            query: (coursePrice) => ({
                url: `course-price/${coursePrice.id}`,
                method: 'PUT',
                body: coursePrice,
            }),
            invalidatesTags: [{ type: 'CoursePrice', id: 'LIST' }],
        }),

        deleteCoursePrice: build.mutation<void, number>({
            query: (id) => ({
                url: `/course-price/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'CoursePrice', id },
            ],
        }),

        activateCoursePrice: build.mutation<void, number>({
            query: (id) => ({
                url: `/course-price/activate/${id}`,
                method: 'PUT',
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'CoursePrice', id },
            ],
        }),
    }),
})
